<script>
  import { onMount } from "svelte";
  import Scrolly from "./lib/Scrolly.svelte";

  let appContainer; // Reference to the app container
  let scrollyId; // The value of the data-scrolly attribute
  let externalData;
  onMount(() => {
    if (appContainer) {
      const parentContainer = appContainer.parentElement;
      //console.log("onMount app.svelte", appContainer, parentContainer);
      scrollyId = parentContainer.getAttribute("data-scrolly"); // Access the data-scrolly attribute
      //console.log("Scrolly ID in App.svelte:", scrollyId);
      externalData = window[`myData_${scrollyId}`];
    }
  });
</script>

<main bind:this={appContainer}>
  <Scrolly {scrollyId} {externalData} />
</main>
